// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { generateHeaders, createResponseObj } from '..'
import { vcBaseUrl } from '.'


type AddPledgeResponse = (SuccessResponse & {
    message: string
    pledgeId: string
}) | FailedResponse

export class AddPledgeRequest extends Request {
    private pledge: Pledge

    private constructor(groupId: string, pledge: Pledge, init?: RequestInit) {
        super(`${vcBaseUrl}/group/${groupId}/pledge`, init)
        this.pledge = pledge
    }

    static async init(groupId: string, pledge: Pledge, init?: RequestInit) {
        return new AddPledgeRequest(groupId, pledge, {
            ...init,
            method: 'POST',
            headers: await generateHeaders("Clerk-Token", init?.headers),
            body: JSON.stringify(pledge) // ToDo: Handle merging BodyInits
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<Pledge> {
        const response = await fetch(this)
        const data = createResponseObj<AddPledgeResponse>(await response.json())
        console.info("Add Pledge Results:", data)

        switch (data.status) {
            case 'successful': return { ...this.pledge, id: data.pledgeId }
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}